export default "__VITE_ASSET__CAxOWsfr__"